import { useTranslation } from 'react-i18next';
import { DialogShellNav, cn } from '@bliks-io/ui';
import { PARTNER_MATERIAL_LOCALES, type PartnerMaterialLocale } from '@bliks-io/contracts';
import { PARTNER_MATERIAL_LOCALE_NAMES } from '@/lib/partner-material-text';

export type LocaleCompleteness = 'complete' | 'partial' | 'empty';

const DOT_CLASSES: Record<LocaleCompleteness, string> = {
  complete: 'bg-positive',
  partial: 'bg-warning-solid',
  empty: 'bg-line-strong'
};

const COMPLETENESS_KEYS: Record<LocaleCompleteness, string> = {
  complete: 'partnerContent.completeness.complete',
  partial: 'partnerContent.completeness.partial',
  empty: 'partnerContent.completeness.empty'
};

/** The editor's language rail: a dot per language shows what is done, half done or missing. */
export function LocaleNav({
  active,
  onSelect,
  completeness
}: {
  active: PartnerMaterialLocale;
  onSelect: (locale: PartnerMaterialLocale) => void;
  completeness: Record<PartnerMaterialLocale, LocaleCompleteness>;
}) {
  const { t } = useTranslation();
  return (
    <DialogShellNav
      aria-label={t('partnerContent.languages.title')}
      activeStyle="flat"
      sections={[
        {
          id: 'languages',
          heading: t('partnerContent.languages.title'),
          items: PARTNER_MATERIAL_LOCALES.map((locale) => ({
            id: locale,
            label: PARTNER_MATERIAL_LOCALE_NAMES[locale],
            active: locale === active,
            onSelect: () => onSelect(locale),
            trailing: (
              <span
                className={cn('h-2 w-2 shrink-0 rounded-full', DOT_CLASSES[completeness[locale]])}
                title={t(COMPLETENESS_KEYS[completeness[locale]])}
              />
            )
          }))
        }
      ]}
    />
  );
}
